import React, { useState } from "react";
import { Box, Text, Flex, Button, Divider } from "@chakra-ui/react";

import Topbar from "components/topbar";
import MainLayout from "components/mainLayout";
import NotificationCard from "components/NotificationCard";

const notificationData = [
  {
    id: 1,
    type: "Change",
    message: "Your bag is now Transferring",
    time: "1hr ago",
    isRead: false,
  },
  {
    id: 2,
    type: "Approval",
    message: "Products are waiting for Seller's approval",
    time: "1hr ago",
    isRead: false,
  },
  {
    id: 3,
    type: "Change",
    message: "Your product has been Live now",
    time: "1hr ago",
    isRead: false,
  },
  {
    id: 4,
    type: "Change",
    message: "Your product has been Sold",
    time: "1hr ago",
    isRead: false,
  },
  {
    id: 5,
    type: "Change",
    message: "Your product has been rejected",
    time: "1hr ago",
    isRead: false,
  },
  {
    id: 6,
    type: "Change",
    message: "Your product has been approved",
    time: "1hr ago",
    isRead: false,
  },
  {
    id: 7,
    type: "Change",
    message: "Your product has been canceled",
    time: "1hr ago",
    isRead: false,
  },
];

const Notifications = () => {
  const [notifications, setNotifications] = useState(notificationData);

  const markAsRead = (id) => {
    setNotifications(
      notifications.map((n) => (n.id === id ? { ...n, isRead: true } : n))
    );
  };

  return (
    <MainLayout>
      <Box minH={"100vh"} h={"100%"}>
        <Topbar title={" Profile"} />
        <Flex bg={"#f8fbff"} padding={4} gap={2}>
          <Flex
            flex={1}
            direction={"column"}
            justifyContent={"space-between"}
            bg={"#FFFFFF"}
            padding={6}
            maxHeight={"100%"}
            borderRadius={"16px"}
            gap={6}
          >
            {/* <Box> */}
            <Text
              fontFamily={"PlusJakartaSansSemiBold"}
              fontSize={"24px"}
              lineHeight={"32px"}
              textTransform={"capitalize"}
              color={"#000000"}
            >
              Notifications
            </Text>
            <Divider bg={"#8A8F9333"} h={"1px"} />
            {/* Scrollable Notifications */}
            <Box
            // maxH="400px"
            //   overflowY="auto"
            //   pr="2"
            //   sx={{
            //     "&::-webkit-scrollbar": { display: "none" },
            //     "-ms-overflow-style": "none",
            //     "scrollbar-width": "none",
            //   }}
            >
              {notifications.map((notification) => (
                <NotificationCard
                  key={notification.id}
                  notification={notification}
                  onRead={() => markAsRead(notification.id)}
                />
              ))}
            </Box>
            {/* Buttons */}
            <Flex
              alignSelf={"flex-end"}
              justifyContent={"flex-end"}
              w={"100%"}
              gap={2}
              mt={4}
            >
              <Button
                // onClick={() => {}}
                flex={1}
                maxW={"148px"}
                background={"transparent"}
                color={"#000000"}
                border={"1px solid #000000"}
                borderRadius={8}
                fontSize={"12px"}
                fontFamily={"PlusJakartaSansMedium"}
                textTransform={"uppercase"}
              >
                Cancel
              </Button>
              <Button
                // onClick={() => {}}
                flex={1}
                maxW={"148px"}
                background={"#000000"}
                color={"#FFFFFF"}
                borderRadius={8}
                fontSize={"12px"}
                fontFamily={"PlusJakartaSansMedium"}
                textTransform={"uppercase"}
                // isDisabled={editMutation.isLoading}
                _disabled={{
                  bg: "grey.100",
                  cursor: "default",
                  _hover: {
                    bg: "grey.100",
                    cursor: "default",
                  },
                }}
              >
                Save
              </Button>
            </Flex>
          </Flex>
        </Flex>
      </Box>
    </MainLayout>
  );
};

export default Notifications;
